import { DbdInterface } from 'store/ducks/dbds/types';

export const getDbdPlace = (dbd: DbdInterface) => {
  if (!dbd) return '---';

  let text = 'Não instalado';
  if (dbd != null) {
    if (dbd.Car != null) {
      text = `Carro: ${dbd.Car.license} - ${dbd.Car.prefix}`;
    } else if (dbd.Block != null) {
      text = `Bloqueio: ${dbd.Block.name}`;
    }
  }
  return text;
};
